import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { BaseURL, uniqueToken, BaseSocketURL } from '../../api/DataApis';
import "./Station.css";
import "./Edit.css";
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import axios from 'axios';
const ChargerLiveStatus = () => {
  document.title = "Charger Live Status";
  const [stations, setStations] = useState([]);
  const [selectedDaysFilter, setselectedDaysFilter] = useState("today");

  const handleDaysFilter = (e) => {
    setselectedDaysFilter(e.target.value);
  }

  useEffect(() => {
    const fetchStations = async () => {
      try {
        const response = await fetch(`${BaseURL}/dashboard/station-charger-listing`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${uniqueToken}`,
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        if (data?.status === 200) {
          setStations(data.data || []);
        } else {
          console.error('Error: Unexpected response structure or status code:', data.status);
        }
      } catch (error) {
        console.error('Error fetching station data:', error);
      }
    };
  
    // Fetch initially
    fetchStations();
  
    // Set an interval to refetch the data every 60 seconds (60000 ms)
    const intervalId = setInterval(fetchStations, 60000);
  
    // Open WebSocket connection for real-time updates
    const socketUrl = `${BaseSocketURL}/evtor?secret=evtorwebsocket@2024`;
    const socket = new WebSocket(socketUrl);
  
    // Handle WebSocket connection open
    socket.onopen = () => {
      console.log("WebSocket connection established");
    };
  
    // Handle WebSocket messages
    socket.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        //console.log('Received WebSocket message:', message);
  
        // Ensure that the message contains an IMEI number and status
        if (message.IMEI) {
          console.log("message.IMEI.......", message.IMEI);
          const connectorStatus = message.S ? "Charging" : "Available";
          console.log("connectorStatussssssssss", connectorStatus)
  
          // Use functional updates to ensure you're working with the latest state
          setStations((prevStations) =>
            prevStations.map(station => ({
              ...station,
              
              charger: station.charger.map(charger =>
                charger.imei_number === message.IMEI
                  ? {
                      ...charger,
                      Property : "LeadAcid",
                      connectors: charger.connectors.map((connector, index) =>
                        index === 0 ? { ...connector, connector_status: connectorStatus } : connector
                      )
                    }
                  : charger
              )
            }))
          );

        } else {
          console.warn("Unexpected WebSocket message format:", message);
        }
      } catch (error) {
        console.error('Error processing WebSocket message:', error);
      }
    };
  
    // Handle WebSocket errors
    socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };
  
    // Handle WebSocket close
    socket.onclose = () => {
      console.log("WebSocket connection closed");
    };
  
    // Clean up WebSocket connection and interval on component unmount
    return () => {
      clearInterval(intervalId); // Clear interval on unmount
      if (socket) {
        socket.close(); // Close WebSocket connection
      }
    };
  }, [BaseURL, uniqueToken]);
  

  const getChargerClass = (status) => {
    if (!status) return "charger-default"; 
    switch (status) {
      case "Available":
        return "charger-available";
      case "Charging":
        return "charger-charging";
      case "NotAvailable":
        return "charger-not-available";
      default:
        return "charger-default";
    }
  };

  const handleStationNameChange = async (station, charger) => {
    try {
        // Initial processing alert with loading
        Swal.fire({
            title: 'Processing...',
            text: 'Please wait...',
            allowOutsideClick: false,
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            didOpen: () => {
                Swal.showLoading(); // Initial loading spinner
            },
        });

        // Function to fetch transaction data based on filter
        const fetchTransactionData = async (filter) => {
            const transactionResponse = await axios.get(
                `${BaseURL}/dashboard/station-dashboard/${station?._id}?date_wise=${filter}`,
                {
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                        Authorization: `Bearer ${uniqueToken}`,
                    },
                }
            );
            return transactionResponse?.data?.data;
        };

        const transactionData = await fetchTransactionData(selectedDaysFilter);

        // Generate table rows
        const generateTableRows = (data) => {
            const rows = Object.entries(data?.charger).map(([chargerEmi, data]) => `
                <tr>
                    <td>${chargerEmi}</td>
                    <td style="text-align: center;">${data?.totalTransaction || "NA"}</td>
                    <td style="text-align: center;">${data?.totalPowerConsumption || "NA"}</td>
                    <td style="text-align: center;">${data?.totalPowerConsumptionAmount || "NA"}</td>
                </tr>
            `);
            const total = data?.total;
            const totalRow = `
                <tr style="font-weight: bold; background-color: #f3f3f3;">
                    <td>Total</td>
                    <td style="text-align: center;">${total?.totalTransaction || "NA"}</td>
                    <td style="text-align: center;">${total?.totalPowerConsumption || "NA"}</td>
                    <td style="text-align: center;">${total?.totalPowerConsumptionAmount || "NA"}</td>
                </tr>
            `;
            return [...rows, totalRow].join('');
        };

        // SweetAlert modal with transaction details and filter select
        Swal.fire({
            width: '90%',
            html: `
                <div style="max-width: 100%; overflow-x: auto; margin-top: 0; position: relative;">
                    <div style="font-weight: bold; margin-bottom: 5px; padding: 5px; border-radius: 5px; background-color: #f3f3f3;">
                        <strong>Evtor Data Analysis (${station?.station_name})</strong>
                    </div>
                    <div style="margin-top: 10px; text-align: right;">
                        <select id="filterSelect" style="width: 15%; padding: 5px; border-radius: 4px; font-size: 12px;" onchange="handleDaysFilter(event)">
                            <option value="today">Today</option>
                            <option value="last_3_days">Last 3 Days</option>
                            <option value="last_7_days">Last 7 Days</option>
                            <option value="last_30_days">Last 30 Days</option>
                        </select>
                    </div>
                    <div id="overlay-loader" style="display: none; position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.8); z-index: 10; justify-content: center; align-items: center;">
                        <div class="spinner"></div>
                    </div>
                    <table style="table-layout: auto; width: 100%; border-collapse: collapse; text-align: left; font-size: 12px;" border="1">
                        <thead>
                            <tr>
                                <th style="font-size: 12px;">IMEI Number</th>
                                <th style="text-align: center; font-size: 12px;">Total Transactions</th>
                                <th style="text-align: center; font-size: 12px;">Power Consumptions</th>
                                <th style="text-align: center; font-size: 12px;">Power Consumption Amount</th>
                            </tr>
                        </thead>
                        <tbody id="table-body">
                            ${generateTableRows(transactionData)}
                        </tbody>
                    </table>
                </div>
            `,
            showCloseButton: true,
            showConfirmButton: false,
            didOpen: () => {
                Swal.hideLoading(); // Hide initial loading spinner
            }
        });

        // Attach event listener to the filter select box
        window.handleDaysFilter = async (event) => {
            const selectedFilter = event.target.value;

            // Show custom overlay loader above the listing
            document.getElementById('overlay-loader').style.display = 'flex';

            try {
                const updatedTransactionData = await fetchTransactionData(selectedFilter);
                
                // Update the table rows in Swal modal with new data
                document.getElementById('table-body').innerHTML = generateTableRows(updatedTransactionData);

                // Hide custom overlay loader
                document.getElementById('overlay-loader').style.display = 'none';
                
            } catch (error) {
                console.error('Error fetching updated transaction data:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch transaction details.',
                });
                document.getElementById('overlay-loader').style.display = 'none'; // Hide loader in case of error
            }
        };
    } catch (error) {
        console.error('Error fetching transaction data:', error);
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to fetch transaction details.',
        });
    }
};


  
  
  
  
  
 const handleSelectChange = async (charger)  => {
    console.log("chargerrrrrrrrrr", charger);
    try {
      Swal.fire({
        title: 'Processing...',
        text: 'Please wait...',
        allowOutsideClick: false,
        showCancelButton: true, // Enables the cancel button
        cancelButtonText: 'Cancel', // Text for the cancel button
        didOpen: () => {
          Swal.showLoading();
        },
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          // Handle cancel action
          Swal.fire('Cancelled', 'The operation was cancelled', 'error');
        }
      });
      //?.meterTransactions?._id, meter?.name, meter?.imei_number, meter?.email
      // Fetch transaction data
      const transactionResponse = await axios.get(`${BaseURL}/dashboard/charger-dashboard/${charger?.imei_number}`, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
      const transactionData = transactionResponse?.data?.data;
      console.log("transactionDataaaaaaaa", transactionData);
      Swal.close();

      // Access meterTransactions[0].meterValueLogs (Ensure the array is accessed properly)
      

      // Show the pop-up with transaction details




      Swal.fire({
        title: `
         <div style="max-width: 100%; padding: 5px; background-color: #f9f9f9; font-size: 12px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); text-align:left;">
            <h4 style="font-size: 14px; text-align: center; font-weight: bold; color: #333;">Evtor Analysis Report</h4>
      
            <div style="display: flex; flex-wrap: wrap; gap: 8px; padding: 2px 0; border-bottom: 1px solid #ddd;">
              <div style="flex: 1; min-width: 150px; display: flex; justify-content: space-between;">
                <label style="font-weight: bold; color: #555;">Charger Name:</label>
                <span style="color: #333;">${charger?.charger_name || 'NA'}</span>
              </div>
              <div style="flex: 1; min-width: 150px; display: flex; justify-content: space-between;">
                <label style="font-weight: bold; color: #555;">EMI Number:</label>
                <span style="color: #333;">${charger?.imei_number || 'NA'}</span>
              </div>
            </div>
      <div style="display: flex; flex-wrap: wrap; gap: 8px; padding: 2px 0; border-bottom: 1px solid #ddd;">
              <div style="flex: 1; min-width: 150px; display: flex; justify-content: space-between;">
                <label style="font-weight: bold; color: #555;">Total No of Transactions:</label>
                <span style="color: #333;">${transactionData?.todayResult?.totalTransaction}</span>
              </div>
              <div style="flex: 1; min-width: 150px; display: flex; justify-content: space-between;">
                <label style="font-weight: bold; color: #555;">Today Amount:</label>
                <span style="color: #333;">${transactionData?.todayResult?.totalPowerConsuptionAmount || "NA"}</span>
              </div>
            </div>
      
            <div style="display: flex; flex-wrap: wrap; padding: 2px 0; border-bottom: 1px solid #ddd;">
              <div style="flex: 1; min-width: 150px; display: flex; justify-content: space-between;">
                <label style="font-weight: bold; color: #555;">Today's Consumption:</label>
                <span style="color: #333;">${transactionData?.todayResult?.totalPowerConsuption || 'NA'}</span>
              </div>
            </div>
          </div>
        `,
        width: '90%',
        html: `
          <div style="max-width: 100%; overflow-x: auto; margin-top: 0;">
            <div style="font-weight: bold; margin-bottom: 5px; padding: 5px; border-radius: 5px; background-color: #f3f3f3;">
              <strong>Evtor Data Analysis</strong>
            </div>
            <table style="table-layout: auto; width: 100%; border-collapse: collapse; text-align: left; font-size: 12px;" border="1">
              <thead>
                <tr>
                  <th style="font-size: 12px;">Types of Consumption</th>
                  <th style="text-align: center; font-size: 12px;">Current</th>
                  <th style="text-align: center; font-size: 12px;">3 Days Ago</th>
                  <th style="text-align: center; font-size: 12px;">7 Days Ago</th>
                  <th style="text-align: center; font-size: 12px;">30 Days Ago</th>
                  <th style="text-align: center; font-size: 12px;">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><b>Today's Consumption</b></td>
                  <td>${transactionData?.todayResult?.totalPowerConsuption || 'NA'}</td>
                  <td>${transactionData?.threeDaysResult?.totalPowerConsuption || 'NA'}</td>
                  <td>${transactionData?.sevenDaysResult?.totalPowerConsuption || 'NA'}</td>
                  <td>${transactionData?.thirtyDaysResult?.totalPowerConsuption || 'NA'}</td>
                  <td>${transactionData?.result?.totalPowerConsuption || 'NA'}</td>
                </tr>
                <tr>
                  <td><b>Today's Amount</b></td>
                  <td>${transactionData?.todayResult?.totalPowerConsuptionAmount || 'NA'}</td>
                  <td>${transactionData?.threeDaysResult?.totalPowerConsuptionAmount || 'NA'}</td>
                  <td>${transactionData?.sevenDaysResult?.totalPowerConsuptionAmount || 'NA'}</td>
                  <td>${transactionData?.thirtyDaysResult?.totalPowerConsuptionAmount || 'NA'}</td>
                  <td>${transactionData?.result?.totalPowerConsuptionAmount || 'NA'}</td>
                </tr>
                <tr>
                  <td><b>Total Transactions</b></td>
                  <td>${transactionData?.todayResult?.totalTransaction || 'NA'}</td>
                  <td>${transactionData?.threeDaysResult?.totalTransaction || 'NA'}</td>
                  <td>${transactionData?.sevenDaysResult?.totalTransaction || 'NA'}</td>
                  <td>${transactionData?.thirtyDaysResult?.totalTransaction || 'NA'}</td>
                  <td>${transactionData?.result?.totalTransaction || 'NA'}</td>
                </tr>
              </tbody>
            </table>
          </div>


        `,

        
        showCloseButton: true,
        showConfirmButton: false
      });
      
    } catch (error) {
      console.error('Error fetching transaction data:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to fetch transaction details.',
      });
    }
  };

 

  const renderChargers = () => {
    const chargerElements = [];
    
    stations.forEach((station, stationIndex) => {
      if (station.charger && station.charger.length > 0) {
        chargerElements.push(
          <div class="common_div_both">
          <div key={`station-${stationIndex}`} className="station-row" >
          <div className="station-heading clickable" >
        <strong  onClick={(e) => handleStationNameChange(station)}>{station?.station_name}</strong>

</div>



            <div className="chargers-flex-container">
              {station.charger.map((charger, idx) => (
                <div
                  key={`${stationIndex}-${idx}`}
                  className="charger-flex-item"
                >
                 <div
  className={`child-div ${getChargerClass(charger?.connectors[0]?.connector_status)} clickable ${
    charger?.charger_ion_type === "lead-acid" ? 'square' : ''
  }`}
  onClick={() => handleSelectChange(charger)}
>
  <strong>{charger?.imei_number.slice(-6)}</strong> {/* Display last 6 digits of IMEI */}
</div>

                </div>
              ))}
            </div>
          </div>
          </div>
        );
      }
    });

    return chargerElements;
  };
console.log("sttaionssssDataaaaa", stations);
  return (
    <>
  
    <Container fluid={true} className="dashboard-default-sec" style={{ paddingLeft: "16px" }}>
    
      {renderChargers()}
    </Container>
    </>

  );
};

export default ChargerLiveStatus;
